module.exports = __webpack_public_path__ + "media/images/close-icon-e39ba1319983f64fec7ce6638999b0ba.png";